import { LanguagesStateInterface } from 'mph-helper';
import { http } from '@/http';

export class LanguagesService {
  static getLanguages(): Promise<LanguagesStateInterface['languages']> {
    return http.get('/commons/languages')
      .then(({ data }) => data);
  }
}
